module.exports = __webpack_public_path__ + "img/rope-painting-farrer-park.063377e7.jpg";